module.exports = __webpack_public_path__ + "static/n.56c59f23.gif";


//////////////////
// WEBPACK FOOTER
// ./src/content/blog/2018/yarn-vs-npm/n.gif
// module id = 602
// module chunks = 261970102678629